/* src/app/shared/strava-sticker/strava-sticker.component.scss */
.main {
  text-align: center;
  pointer-events: none;
}
h3,
h1 {
  margin: 0;
}
.light {
  color: white;
  text-shadow: 0 0 2px gray;
}
.dark {
  color: black;
}
/*# sourceMappingURL=strava-sticker.component.css.map */
